import { Col, Row, Typography } from "antd";
import "../../assets/css/campaignAnalytics.css"

export default function ChannelsPageServiceTitle({ appProperties, serviceName = "", removeTitleIcon, title, icon }) {
  const iconClassName = appProperties?.providerCommonObj?.serviceNotAuthorizedTitleIcon || "stepOneAuthorizeIcon";

  return (
    <Row className="d-flex align-items-center h-100">
      {!removeTitleIcon && <Col className={`me-2`}>{icon ?? <div className={`staticIconsSprite ${iconClassName}`}/>} </Col>}
      <span>
        <Typography.Title
          style={{
            color: "#374151",
            textTransform: "capitalize",
            fontSize: 16,
            fontWeight: 500,
            paddingTop: 10,
          }}
        >
          {title || `Authorize ${serviceName}`}
        </Typography.Title>
      </span>
    </Row>
  );
}
